module.exports = __webpack_public_path__ + "static/media/wheeled-BG-6th-layer-six@2x.59360de5.png";